export default "__VITE_ASSET__DABOl7O0__"